import * as React from "react";
import {
  Button,
  ButtonContext,
  ComboBoxStateContext,
  OverlayTriggerStateContext,
  SelectStateContext,
  useSlottedContext,
} from "react-aria-components";
import { ChevronDown, ChevronRight } from "../../icons/line.tsx";
import { button, chevronIcon, treeExpandButton } from "./ChevronButton.css.ts";

export const TreeExpandChevron: React.FC<{ isOpen?: boolean }> = ({
  isOpen,
}) => (
  <Button slot="chevron" className={treeExpandButton}>
    <ChevronRight className={chevronIcon({ isOpen })} />
  </Button>
);

export const ChevronButton: React.FC<{
  isOpen?: boolean;
  onClick?: () => void;
}> = ({ isOpen: isOpenProp, onClick }) => {
  const comboBoxState = React.use(ComboBoxStateContext);
  const selectState = comboBoxState ? null : React.use(SelectStateContext);
  const overlayState =
    comboBoxState || selectState ? null : React.use(OverlayTriggerStateContext);

  const isOpen =
    isOpenProp ??
    comboBoxState?.isOpen ??
    selectState?.isOpen ??
    overlayState?.isOpen ??
    false;
  const isFieldDisabled = useSlottedContext(ButtonContext)?.isDisabled === true;

  return (
    <Button
      slot={null}
      aria-hidden="true"
      excludeFromTabOrder
      isDisabled={isFieldDisabled}
      data-testid="chevron-button"
      className={button}
      onPress={() => {
        if (comboBoxState) {
          comboBoxState.toggle(null, "manual");
        } else if (selectState) {
          selectState.setOpen(!selectState.isOpen);
        } else if (overlayState) {
          overlayState.setOpen(!overlayState.isOpen);
        } else if (onClick) {
          onClick();
        }
      }}
    >
      <ChevronDown className={chevronIcon({ isOpen })} />
    </Button>
  );
};
